import PlusIcon from '@assets/icons/plus.svg';
import React from 'react';
import { ActivityIndicator } from './activity-indicator';
import { CircledIcon, CircleIconSize } from './circled-icon';
import { ListItem } from './list-item';
import { SCREEN_PADDING } from '@/styles';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

interface Props {
  disabled?: boolean;
  listItemStyle?: StyleProp<ViewStyle>;
  loading?: boolean;
  onSelect: () => void;
  size?: CircleIconSize;
  testID?: string;
  title: string;
}

export const AddNewFooter: React.FC<Props> = ({
  disabled,
  loading,
  onSelect,
  size = 'medium',
  testID,
  title,
  listItemStyle,
}) => {
  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator testID="activity-indicator" />
      </View>
    );
  }

  return (
    <ListItem
      disabled={disabled}
      item={{
        title: title,
        value: '',
      }}
      listItemStyle={[
        styles.listItem,
        disabled ? styles.disabled : null,
        listItemStyle,
      ]}
      onSelect={() => {
        if (!disabled) {
          onSelect();
        }
      }}
      renderLeftComponent={() => (
        <CircledIcon
          Icon={PlusIcon}
          iconHeight={20}
          iconWidth={20}
          size={size}
        />
      )}
      testID={testID}
    />
  );
};

const styles = StyleSheet.create({
  disabled: {
    opacity: 0.4,
  },
  listItem: {
    paddingHorizontal: SCREEN_PADDING,
  },
  loadingContainer: {
    height: 60,
    justifyContent: 'center',
  },
});
